import { isProd } from "@/config/common";
import {
  ContentfulLocaleEnum,
  CountryCodeEnum,
  CountryNameEnum,
  CurrencyCodeEnum,
  DomainEnum,
  ElevateCodeEnum,
  LanguageCodeEnum,
  type Market,
  PSPEnum,
  SiteLocaleEnum,
  SiteNameEnum,
} from "./i18n-config";

export const sk: Market = {
  psp: PSPEnum.ADYEN,
  flag: "🇸🇰",
  currency: CurrencyCodeEnum.EUR,
  countryCode: CountryCodeEnum.SK,
  countryName: CountryNameEnum.SK,
  languageCode: LanguageCodeEnum.EN,
  locale: `${LanguageCodeEnum.EN}-${CountryCodeEnum.SK}`,
  upperCaseLocale: `${LanguageCodeEnum.EN}-${CountryCodeEnum.SK.toUpperCase()}`,
  contentfulLocale: ContentfulLocaleEnum.EU,
  siteLocale: SiteLocaleEnum.SK,
  elevateMarket: ElevateCodeEnum.EU,
  externalStoreId: "ecom-noga",
  searchPathName: "/search",
  domain: DomainEnum.NOGA,
  imageCdn: isProd()
    ? "https://cdn.no-ga.com"
    : "https://media.stage.cdn-norce.tech/1413",
  siteName: SiteNameEnum.EU,
};
